module.exports = __webpack_public_path__ + "static/img/no photo.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no photo.jpg
// module id = BNhh
// module chunks = 0